import { useEffect, useState, useMemo } from "react";
import { decode as base64_decode } from "base-64";
import { useLocation, useHistory } from "react-router-dom";
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import { Tooltip } from '@mui/material';

// Funções auxiliares
const parseArray = (val) => {
  if (!val) return [];
  if (Array.isArray(val)) return val;

  try {
    return JSON.parse(val);
  } catch {
    return [];
  }
};

const getUsers = () => {
  try {
    const raw = sessionStorage.getItem('ddesp');
    if (!raw) return null;
    return JSON.parse(base64_decode(raw));
  } catch {
    console.error("Erro ao ler session ddesp");
    return null;
  }
};

// Componente
const CupomDesconto = () => {
  const location = useLocation();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [banner, setBanner] = useState(null);
  const [copiado, setCopiado] = useState(false);

  // Formata dados da promoção
  const promoData = useMemo(() => {
    const users = getUsers();
    const promo = users?.[35]?.[0];
    if (!promo) return null;

    return {
      background: promo.background ?? '#343a40',
      textColor: promo.text_color ?? '#ffffff',
      titulo: promo.descricao ?? 'Promoção',
      subtitulo: promo.subtitulo ?? '',
      desconto: promo.desconto_label ?? '—',
      validade: promo.data_vencimento ?? '',
      bannerUrl: promo.url_imagem ?? null,
      tag: promo.tag ?? 'Promoção',
      beneficios: parseArray(promo.beneficios),
      cupom: promo.cupom ?? null,
      paginas: parseArray(promo.paginas),
      quemVe: promo.quem_ve,
      quemVeExt: parseArray(promo.quem_ve_ext),
      persistencia: promo.persistencia ?? 0,
      modelo: promo.modelo ?? 0,
    };
  }, []);







  // Estilo do tema
  const themeStyles = useMemo(() => ({
    background: promoData?.background || '#343a40',
    color: promoData?.textColor || '#ffffff',
  }), [promoData]);

  // Controle da exibição do modal
  useEffect(() => {
    const users = getUsers();
    if (!users || !promoData) return;

    const planoId = users[8];
    const caminhoAtual = location.pathname;

    // Verifica se rota está liberada
    if (!promoData.paginas.includes(caminhoAtual)) {
      setShowModal(false);
      return;
    }

    // Quem pode ver
    if (promoData.quemVe === "0") {
      if (!promoData.quemVeExt.includes(Number(planoId))) {
        return;
      }
    }

    // Persistência por dia
    const hoje = new Date().toISOString().split('T')[0];
    const persistLocal = JSON.parse(localStorage.getItem('persistcp') || '[]');
    const atual = persistLocal[0];

    if (atual?.data === hoje) {
      if (atual.pst < promoData.persistencia) {
        localStorage.setItem('persistcp', JSON.stringify([{ data: hoje, pst: atual.pst + 1 }]));
        setTimeout(() => setShowModal(true), 3000);
      }
    } else {
      localStorage.setItem('persistcp', JSON.stringify([{ data: hoje, pst: 1 }]));
      setTimeout(() => setShowModal(true), 3000);
    }

  }, [location, promoData]);


  // Carrega banner ao abrir
  useEffect(() => {
    if (!showModal) return;
    if (banner) return;

    setBanner(promoData?.bannerUrl || null);
  }, [showModal, promoData, banner]);

  // Ações
  const handleClose = () => setShowModal(false);

  const handleCta = () => {
    setShowModal(false);
  };

  const handleNaoExibirNovamente = () => {
    localStorage.setItem('persistcp', JSON.stringify([{ data: new Date().toISOString().split('T')[0], pst: promoData.persistencia }]));
    setShowModal(false);
  }

  const copiarCupom = () => {
    if (!promoData?.cupom) return;

    navigator.clipboard.writeText(promoData.cupom)
      .then(() => {
        setCopiado(true);
        setTimeout(() => setCopiado(false), 2000);
      })
      .catch(() => console.error('Erro ao copiar cupom.'));
  };

  if (!promoData) return null;
  // 

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      size="lg"
      centered
      backdrop="static"
      backdropClassName="espiao-promo-backdrop"
      className={themeStyles.color}
      contentClassName="espiao-promo-content"
    >
      {promoData.modelo !== 1 && (
        <Modal.Header closeButton className={themeStyles.background}>
          <div className="w-100 d-flex justify-content-between align-items-center">
            <div>
              <div
                className="d-inline-flex align-items-center px-2 py-1"
                style={{
                  background: 'rgba(255,255,255,0.12)',
                  borderRadius: 999,
                  fontWeight: 400,
                }}
              >
                <i className="mdi mdi-tag-multiple mr-1"></i>
                {promoData.tag}
              </div>

              <h5 className={`mb-0 mt-2 ${themeStyles.color}`}>
                <strong>{promoData.titulo}</strong>
              </h5>

              <small style={{ opacity: 0.9 }}>
                {promoData.subtitulo}
              </small>
            </div>
          </div>
        </Modal.Header>
      )}

      <Modal.Body 
        className={themeStyles.background}
        style={promoData.modelo === 1 ? { padding: 0, height: '80vh' } : {}}
      >
        {/* Modelo 0: Layout completo (padrão) */}
        {promoData.modelo === 0 && (
          <Row>
            {/* Banner */}
            <Col md={6} className="d-flex flex-column">
              <div className="">
                {banner ? (
                  <img
                    src={banner}
                    alt="Promoção"
                    style={{ maxWidth: '100%', maxHeight: 320, borderRadius: '12px' }}
                  />
                ) : (
                  <div className="text-center p-4 w-100">
                    <div
                      className={`mx-auto mb-3 ${themeStyles.color}`}
                      style={{
                        background: 'rgba(255,255,255,0.1)',
                        padding: '20px 32px',
                        fontSize: '32px',
                        fontWeight: 700,
                        borderRadius: 12,
                      }}
                    >
                      {promoData.desconto}
                    </div>
                  </div>
                )}
              </div>
              <div className="mt-2">
                <Form.Check
                  type="checkbox"
                  label="Não exibir mais na data de hoje"
                  style={{ color: 'rgba(255,255,255,0.7)' }}
                  onChange={handleNaoExibirNovamente}
                />
              </div>
            </Col>

            {/* Texto e detalhes */}
            <Col md={6} className={`${themeStyles.color} d-flex flex-column`}>
              {promoData.beneficios.length > 0 && (
                <>
                  <h6 className="mt-0">
                    <i className="mdi mdi-party-popper mr-2 text-warning"></i>
                    Benefícios da promoção
                  </h6>

                  <ul className="mb-3 f-w-400">
                    {promoData.beneficios.map((b, i) => (
                      <li key={i}>{b}</li>
                    ))}
                  </ul>
                </>
              )}

              <div className="alert alert-dark py-2" style={{ borderRadius: '12px' }}>
                <i className="mdi mdi-timer-outline mr-2"></i>
                Condições válidas até {promoData.validade}.
              </div>

              {promoData.cupom && (
                <div className="mt-2 mb-3">
                  <small className="d-block mb-1">Código promocional</small>

                  <div
                    className="d-flex align-items-center justify-content-between px-3 py-1"
                    style={{
                      background: 'rgba(255,255,255,0.1)',
                      borderRadius: '12px',
                      border: '1px dashed rgba(255,255,255,0.2)',
                    }}
                  >
                    <div className="d-flex align-items-center flex-grow-1">
                      <i className="mdi mdi-ticket-percent mr-2" style={{ fontSize: 24 }}></i>
                      <strong style={{
                        fontFamily: 'monospace',
                        fontSize: 18,
                        letterSpacing: 2,
                      }}>
                        {promoData.cupom}
                      </strong>
                    </div>
                    <Tooltip title="Copiar cupom" placement="top" arrow>
                      <Button
                        variant="link"
                        size="sm"
                        className="p-2 ml-2"
                        style={{ color: copiado ? '#28a745' : 'rgba(255,255,255,0.7)' }}
                        onClick={copiarCupom}
                      >
                        <i className={`mdi ${copiado ? 'mdi-check-circle' : 'mdi-content-copy'}`} style={{ fontSize: 20 }}></i>
                        {copiado && <span className="ml-1 small">Copiado!</span>}
                      </Button>
                    </Tooltip>
                  </div>
                </div>
              )}

              <div className="mt-auto d-flex justify-content-end">
                <Button variant="secondary" className="btn-sm mr-2 rounded" onClick={handleClose}>
                  Fechar
                </Button>
                <Button variant="primary" className="btn-sm rounded" onClick={() => {
                  if (promoData?.cupom && navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(promoData.cupom).catch(err => {
                      console.error('Erro ao copiar cupom:', err);
                    });
                  }
                  const hoje = new Date().toISOString().split('T')[0];
                  localStorage.setItem('persistcp', JSON.stringify([{ data: hoje, pst: promoData.persistencia }]));
                  setShowModal(false);
                  history.push('/planos');
                }}>
                  <i className="mdi mdi-lightning-bolt mr-1"></i>
                  Aproveitar
                </Button>
              </div>
            </Col>
          </Row>
        )}

        {/* Modelo 1: Apenas imagem com botão copiar cupom */}
        {promoData.modelo === 1 && (
          <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            {banner && (
              <img
                src={banner}
                alt="Promoção"
                style={{ 
                  width: '100%', 
                  height: '100%', 
                  objectFit: 'cover',
                  display: 'block'
                }}
              />
            )}
            
            {/* Botões posicionados sobre a imagem */}
            <div style={{
              position: 'absolute',
              bottom: '20px',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              gap: '10px',
              zIndex: 10
            }}>
              {promoData.cupom && (
                <Tooltip title="Copiar cupom" placement="top" arrow>
                  <Button
                    variant="success"
                    className="rounded"
                    onClick={copiarCupom}
                    style={{
                      boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                    }}
                  >
                    <i className="mdi mdi-content-copy mr-1"></i>
                    {copiado ? 'Copiado!' : 'Copiar Cupom'}
                  </Button>
                </Tooltip>
              )}
              <Button 
                variant="primary" 
                className="rounded" 
                onClick={() => {
                  if (promoData?.cupom) {
                    navigator.clipboard.writeText(promoData.cupom);
                  }
                  const hoje = new Date().toISOString().split('T')[0];
                  localStorage.setItem('persistcp', JSON.stringify([{ data: hoje, pst: promoData.persistencia }]));
                  history.push('/planos');
                  setShowModal(false);
                }}
                style={{
                  boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                }}
              >
                <i className="mdi mdi-lightning-bolt mr-1"></i>
                Aproveitar Oferta
              </Button>
            </div>

            {/* Botão X no canto superior direito */}
            <button
              type="button"
              className="close"
              onClick={handleClose}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                zIndex: 10,
                background: 'rgba(0,0,0,0.5)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '35px',
                height: '35px',
                fontSize: '24px',
                lineHeight: '1',
                padding: '0',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        )}

        {/* Modelo 2: Apenas textos e lista (sem imagem) */}
        {promoData.modelo === 2 && (
          <div className={`${themeStyles.color}`}>
            {promoData.beneficios.length > 0 && (
              <>
                <h6 className="mt-0">
                  <i className="mdi mdi-party-popper mr-2 text-warning"></i>
                  Benefícios da promoção
                </h6>

                <ul className="mb-3 f-w-400">
                  {promoData.beneficios.map((b, i) => (
                    <li key={i}>{b}</li>
                  ))}
                </ul>
              </>
            )}

            <div className="alert alert-dark py-2" style={{ borderRadius: '12px' }}>
              <i className="mdi mdi-timer-outline mr-2"></i>
              Condições válidas até {promoData.validade}.
            </div>

            {promoData.cupom && (
              <div className="mt-2 mb-3">
                <small className="d-block mb-1">Código promocional</small>

                <div
                  className="d-flex align-items-center justify-content-between px-3 py-1"
                  style={{
                    background: 'rgba(255,255,255,0.1)',
                    borderRadius: '12px',
                    border: '1px dashed rgba(255,255,255,0.2)',
                  }}
                >
                  <div className="d-flex align-items-center flex-grow-1">
                    <i className="mdi mdi-ticket-percent mr-2" style={{ fontSize: 24 }}></i>
                    <strong style={{
                      fontFamily: 'monospace',
                      fontSize: 18,
                      letterSpacing: 2,
                    }}>
                      {promoData.cupom}
                    </strong>
                  </div>
                  <Tooltip title="Copiar cupom" placement="top" arrow>
                    <Button
                      variant="link"
                      size="sm"
                      className="p-2 ml-2"
                      style={{ color: copiado ? '#28a745' : 'rgba(255,255,255,0.7)' }}
                      onClick={copiarCupom}
                    >
                      <i className={`mdi ${copiado ? 'mdi-check-circle' : 'mdi-content-copy'}`} style={{ fontSize: 20 }}></i>
                      {copiado && <span className="ml-1 small">Copiado!</span>}
                    </Button>
                  </Tooltip>
                </div>
              </div>
            )}

            <div className="mt-3">
              <Form.Check
                type="checkbox"
                label="Não exibir mais na data de hoje"
                style={{ color: 'rgba(255,255,255,0.7)' }}
                onChange={handleNaoExibirNovamente}
              />
            </div>

            <div className="mt-3 d-flex justify-content-end">
              <Button variant="secondary" className="btn-sm mr-2 rounded" onClick={handleClose}>
                Fechar
              </Button>
              <Button variant="primary" className="btn-sm rounded" onClick={() => {
                if (promoData?.cupom) {
                  navigator.clipboard.writeText(promoData.cupom);
                }
                const hoje = new Date().toISOString().split('T')[0];
                localStorage.setItem('persistcp', JSON.stringify([{ data: hoje, pst: promoData.persistencia }]));
                setShowModal(false);
                history.push('/planos');
              }}>
                <i className="mdi mdi-lightning-bolt mr-1"></i>
                Aproveitar
              </Button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CupomDesconto;
